import { render, staticRenderFns } from "./editMedicalRecord.vue?vue&type=template&id=165df60c&"
import script from "./editMedicalRecord.vue?vue&type=script&lang=js&"
export * from "./editMedicalRecord.vue?vue&type=script&lang=js&"
import style0 from "./editMedicalRecord.vue?vue&type=style&index=0&id=165df60c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports